import React, { useEffect, useRef } from 'react';
import '../CoursesSection.css';
import uczenBigPhoto from '../../assets/sections/uczen-big.jpg';
import rough from 'roughjs';

const HandDrawnDecorations: React.FC = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  const drawnRef = useRef(false);

  useEffect(() => {
    if (!svgRef.current || drawnRef.current) return;
    drawnRef.current = true;

    const svg = svgRef.current;
    const rc = rough.svg(svg);

    const green = '#70db2e';
    const darkGreen = '#38c027';

    const eqStyle = { stroke: green, strokeWidth: 2.5, roughness: 0.8 };
    const expStyle = { stroke: green, strokeWidth: 2, roughness: 0.6 };

    // Twierdzenie Pitagorasa
    const eqX = 180;
    const eqY = 80;
    svg.appendChild(rc.ellipse(eqX + 48, eqY + 90, 22, 20, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 58} ${eqY + 78} L ${eqX + 58} ${eqY + 100}`, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 68} ${eqY + 68} Q ${eqX + 74} ${eqY + 64} ${eqX + 76} ${eqY + 70} Q ${eqX + 78} ${eqY + 76} ${eqX + 68} ${eqY + 80} L ${eqX + 78} ${eqY + 80}`, expStyle));
    svg.appendChild(rc.path(`M ${eqX + 95} ${eqY + 83} L ${eqX + 95} ${eqY + 98} M ${eqX + 88} ${eqY + 90} L ${eqX + 102} ${eqY + 90}`, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 118} ${eqY + 68} L ${eqX + 118} ${eqY + 100} M ${eqX + 118} ${eqY + 83} Q ${eqX + 130} ${eqY + 78} ${eqX + 132} ${eqY + 88} Q ${eqX + 132} ${eqY + 100} ${eqX + 118} ${eqY + 100}`, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 138} ${eqY + 68} Q ${eqX + 144} ${eqY + 64} ${eqX + 146} ${eqY + 70} Q ${eqX + 148} ${eqY + 76} ${eqX + 138} ${eqY + 80} L ${eqX + 148} ${eqY + 80}`, expStyle));
    svg.appendChild(rc.path(`M ${eqX + 165} ${eqY + 83} L ${eqX + 188} ${eqY + 83} M ${eqX + 165} ${eqY + 95} L ${eqX + 188} ${eqY + 95}`, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 218} ${eqY + 78} Q ${eqX + 205} ${eqY + 76} ${eqX + 205} ${eqY + 90} Q ${eqX + 205} ${eqY + 102} ${eqX + 218} ${eqY + 100}`, eqStyle));
    svg.appendChild(rc.path(`M ${eqX + 222} ${eqY + 68} Q ${eqX + 228} ${eqY + 64} ${eqX + 230} ${eqY + 70} Q ${eqX + 232} ${eqY + 76} ${eqX + 222} ${eqY + 80} L ${eqX + 232} ${eqY + 80}`, expStyle));

    // Trojkat
    svg.appendChild(rc.polygon([[720, 100], [780, 170], [660, 170]], {
      stroke: darkGreen,
      strokeWidth: 2.5,
      roughness: 0.8,
    }));
    svg.appendChild(rc.circle(720, 100, 8, { stroke: darkGreen, strokeWidth: 2, roughness: 0.6 }));
    svg.appendChild(rc.circle(780, 170, 8, { stroke: darkGreen, strokeWidth: 2, roughness: 0.6 }));
    svg.appendChild(rc.circle(660, 170, 8, { stroke: darkGreen, strokeWidth: 2, roughness: 0.6 }));

    // Symbol sumy
    svg.appendChild(rc.path('M 200 300 L 160 300 L 180 340 L 160 380 L 200 380', {
      stroke: darkGreen,
      strokeWidth: 3,
      roughness: 0.8,
    }));

    // x^2
    svg.appendChild(rc.path('M 220 560 L 250 600 M 250 560 L 220 600', {
      stroke: green,
      strokeWidth: 2.5,
      roughness: 0.8,
    }));
    svg.appendChild(rc.path('M 255 552 Q 263 548 265 555 Q 267 562 255 568 L 267 568', {
      stroke: green,
      strokeWidth: 2,
      roughness: 0.6,
    }));

    // Kolko z plusem
    svg.appendChild(rc.circle(780, 560, 35, {
      stroke: darkGreen,
      strokeWidth: 2.5,
      roughness: 0.8,
    }));
    svg.appendChild(rc.path('M 780 540 L 780 580 M 760 560 L 800 560', {
      stroke: darkGreen,
      strokeWidth: 2,
      roughness: 0.6,
    }));

  }, []);

  return (
    <svg
      ref={svgRef}
      className="hand-drawn-decorations"
      viewBox="0 0 1000 700"
      preserveAspectRatio="none"
    />
  );
};

const AuditedCoursesSection: React.FC = () => {
  const courses = [
    {
      title: "Matura Podstawowa",
      icon: "P",
      slug: "matura-podstawowa",
      description: "Solidne przygotowanie do matury na poziomie podstawowym"
    },
    {
      title: "Matura Rozszerzona",
      icon: "R",
      slug: "matura-rozszerzona",
      description: "Intensywny kurs dla ambitnych maturzystow"
    },
    {
      title: "Egzamin Osmoklasisty",
      icon: "8",
      slug: "egzamin-osmoklasisty",
      description: "Kompleksowe przygotowanie do egzaminu"
    },
    {
      title: "Konkursy i Olimpiady",
      icon: "O",
      slug: "konkursy-olimpiady",
      description: "Trening dla przyszlych laureatow"
    },
    {
      title: "Egzaminy Zagraniczne",
      icon: "Z",
      slug: "egzaminy-zagraniczne",
      description: "SAT, IB Math i inne certyfikaty"
    },
    {
      title: "Szkola Podstawowa",
      icon: "S",
      slug: "matematyka-podstawowa",
      description: "Budowanie solidnych fundamentow"
    },
    {
      title: "Indywidualne Potrzeby",
      icon: "I",
      slug: "indywidualne-potrzeby",
      description: "Program dostosowany do Ciebie"
    },
    {
      title: "Nadrabianie Zaleglosci",
      icon: "N",
      slug: "nadrabianie-zaleglosci",
      description: "Szybkie uzupelnienie brakow"
    }
  ];

  const handleCourseClick = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="courses" className="courses-section">
      <div className="geometric-shapes">
        <div className="geo-shape"></div>
        <div className="geo-shape"></div>
        <div className="geo-shape"></div>
        <div className="geo-shape"></div>
      </div>

      <HandDrawnDecorations />

      <div className="courses-container">
        <div className="section-header">
          <h2>Nasza Oferta</h2>
          <p>Kompleksowe wsparcie w nauce matematyki na kazdym poziomie</p>
        </div>

        <div className="offer-layout">
          <div className="center-image-container">
            <img src={uczenBigPhoto} alt="Uczen rozwiazujacy zadania matematyczne" className="center-student-image" />
          </div>

          <div className="courses-surrounding">
            {courses.map((course, index) => (
              <div
                key={index}
                className="course-card"
                onClick={handleCourseClick}
                title={course.description}
              >
                <div className="course-icon">
                  {course.icon}
                </div>
                <h4 className="course-title-small">{course.title}</h4>
                <p className="course-description-small">{course.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedCoursesSection;
